export const borderRadiusMain = '4px';
export const borderRadiusDouble = '8px';
export const borderRadiusCircle = '9999px';
